import { render } from "./ListsPage.vue?vue&type=template&id=140fabc6&scoped=true"
import script from "./ListsPage.vue?vue&type=script&lang=js"
export * from "./ListsPage.vue?vue&type=script&lang=js"

import "./ListsPage.vue?vue&type=style&index=0&id=140fabc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140fabc6"]])

export default __exports__